export default "__VITE_ASSET__CDtBRrBF__"